import api from "./api";
import config from "../config";

export default {
  lookup(email) {
    return new Promise((resolve, reject) => {
      if (!email) {
        return reject(new Error("An email address must be entered."));
      }

      api.request(
        {
          method: "POST",
          endpoint: "people/lookup",
          json: { email },
          ignoreLoginErrors: true
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  login({ email, password, noRedirect, targetResourceType, targetResourceId }) {
    return new Promise((resolve, reject) => {
      if (!email || !password) {
        return reject(new Error("An email address and password are required."));
      }

      api.request(
        {
          method: "POST",
          endpoint: "people/login",
          json: {
            email,
            password,
            event_bucket: config.event_bucket,
            target_resource_type: targetResourceType,
            target_resource_id: targetResourceId
          },
          ignoreLoginErrors: noRedirect
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  register(credentials) {
    return new Promise((resolve, reject) => {
      if (credentials.username) {
        credentials.email = credentials.username;
        delete credentials.username;
      }
      if (!credentials.email || !credentials.password) {
        return reject(new Error("An email address and password are required."));
      }

      api.request(
        {
          method: "POST",
          endpoint: "people",
          json: credentials
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  authFacebook(
    { token, targetResourceType, targetResourceId },
    shouldRegister
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/auth_facebook",
          json: {
            token: token,
            event_bucket: config.event_bucket,
            target_resource_type: targetResourceType,
            target_resource_id: targetResourceId,
            register: shouldRegister
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  authCannes({ username, password }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/auth_cannes",
          json: {
            username,
            password,
            event_bucket: config.event_bucket
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  authEventival({ token, targetResourceType, targetResourceId }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/auth_eventival",
          json: {
            token: token,
            event_bucket: config.event_bucket,
            target_resource_type: targetResourceType,
            target_resource_id: targetResourceId
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  authIda({ token, targetResourceType, targetResourceId }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/auth_ida",
          json: {
            token: token,
            event_bucket: config.event_bucket,
            target_resource_type: targetResourceType,
            target_resource_id: targetResourceId
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  authSundance({ token, externalToken, targetResourceType, targetResourceId }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/auth_sundance",
          json: {
            token: token,
            external_token: externalToken,
            event_bucket: config.event_bucket,
            target_resource_type: targetResourceType,
            target_resource_id: targetResourceId
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

   authAARP({ token, targetResourceType, targetResourceId }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/auth_aarp",
          json: {
            token: token,
            event_bucket: config.event_bucket,
            target_resource_type: targetResourceType,
            target_resource_id: targetResourceId
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  updatePaymentInfo(token, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/self",
          json: {
            token: token,
            payments_token: data.token,
            payment_method: data.payment_method
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(token, data) {
    return new Promise((resolve, reject) => {
      data.token = token;
      api.request(
        {
          method: "POST",
          endpoint: "people/self",
          json: data
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  forgotPassword(email) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/forgot_password",
          json: {
            email: email,
            event_bucket: config.event_bucket,
            reset_url:
              window.location.protocol +
              "//" +
              window.location.host +
              "/reset?token="
          },
          ignoreLoginErrors: true
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  resetPassword(token, password) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "people/reset_password",
          ignoreLoginErrors: true,
          json: {
            token: token,
            password: password
          }
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchSelf(token, isInitialRefresh) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: "people/self",
          qs: { token: token },
          ignoreLoginErrors: isInitialRefresh
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/PersonUtil.js